var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcSystemXDark = function SvgIcSystemXDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.566 4.656-1.062-1.062-7.344 7.346-7.344-7.346-1.062 1.062L11.1 12l-7.346 7.344 1.062 1.062 7.344-7.345 7.344 7.345 1.062-1.062L13.221 12l7.345-7.344z",
    fill: "#fff"
  })));
};
export { SvgIcSystemXDark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Im0yMC41NjYgNC42NTYtMS4wNjItMS4wNjItNy4zNDQgNy4zNDYtNy4zNDQtNy4zNDYtMS4wNjIgMS4wNjJMMTEuMSAxMmwtNy4zNDYgNy4zNDQgMS4wNjIgMS4wNjIgNy4zNDQtNy4zNDUgNy4zNDQgNy4zNDUgMS4wNjItMS4wNjJMMTMuMjIxIDEybDcuMzQ1LTcuMzQ0eiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K";